export const PATHS = {
  login: {
    pathBase: '/login/',
  },
  dashboard: {
    pathBase: '/dashboard/',
  },
  ticket: {
    pathBase: '/generar-ticket/',
    generateVirtualTicket: 'virtual',
    generatePresentialTicket: 'presencial',
  },
  box: {
    pathBase: '/box/',
    assignmentBox: 'asignacion',
    attentionBox: 'atencion',
  },
  reservation: {
    pathBase: '/cita/',
    virtualReservation: 'citas-virtuales',
  },
  errors: {
    deny: '/403',
    notFound: '/404',
    serverError: '/500',
  },
};
